import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {ConcordanceAiPresetEnum} from '../../../../../../service/reivew-analysis/review-analysis-ai-chat/review-analysis-ai-message-type';

export const aiAnalysisPresetsTranslationKeys: Record<ConcordanceAiPresetEnum, LangKeyType> = {
    [ConcordanceAiPresetEnum.SWOT]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__SWOT',
    [ConcordanceAiPresetEnum.NEGATIVE_EXPERIENCE]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__NEGATIVE_EXPERIENCE',
    [ConcordanceAiPresetEnum.POSITIVE_EXPERIENCE]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__POSITIVE_EXPERIENCE',
    [ConcordanceAiPresetEnum.CLIENT_REQUESTS]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__CLIENT_REQUESTS',
    [ConcordanceAiPresetEnum.NEGATIVE_REVIEWS_THEMES]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__NEGATIVE_REVIEWS_THEMES',
    [ConcordanceAiPresetEnum.POSITIVE_REVIEWS_THEMES]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__POSITIVE_REVIEWS_THEMES',
    [ConcordanceAiPresetEnum.EMOTIONAL_TONE_OF_REVIEWS]:
        'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__EMOTIONAL_TONE_OF_REVIEWS',
    [ConcordanceAiPresetEnum.STAFF_MENTIONS_AND_FEEDBACK]:
        'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__STAFF_MENTIONS_AND_FEEDBACK',
};
